import { Box, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Add, CloudUpload, Search } from '@material-ui/icons';
import { Button, SelectField, TextField, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useDebtTrackingStore } from '../../hooks/useDebtTrackingStore';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  warehouse: {
    width: '220px',
  },
  search: {
    width: '320px',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
  },
}));

export const DebtTrackingToolbar = observer(({ onAddEntry, onBulkImport }: { onAddEntry: () => void; onBulkImport: () => void }) => {
  const classes = useStyles();
  const { debtTrackingStore } = useDebtTrackingStore();
  const { warehouses, selectedWarehouseId, searchText } = debtTrackingStore;

  return (
    <Toolbar fullWidth>
      <Box className={classes.container}>
        <Box className={classes.filters}>
          <Box className={classes.warehouse}>
            <SelectField
              testId="debtTrackingWarehouse"
              label="Warehouse"
              variant="outlined"
              fullWidth
              value={selectedWarehouseId ?? ''}
              options={warehouses.map(warehouse => ({ label: warehouse.name, value: warehouse.id }))}
              onChange={value => debtTrackingStore.selectWarehouse(value)}
            />
          </Box>
          <Box className={classes.search}>
            <TextField
              testId="debtTrackingSearch"
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Search by Loan ID or comment..."
              value={searchText}
              onChange={e => debtTrackingStore.setSearchText(e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><Search /></InputAdornment> }}
            />
          </Box>
        </Box>
        <Box className={classes.buttons}>
          <Button
            testId="debtTrackingBulkImport"
            variant="outlined"
            size="small"
            color="primary"
            startIcon={<CloudUpload />}
            onClick={onBulkImport}
          >
            Add in Bulk
          </Button>
          <Button
            testId="debtTrackingAddEntry"
            variant="contained"
            size="small"
            color="primary"
            startIcon={<Add />}
            disabled={!selectedWarehouseId}
            onClick={onAddEntry}
          >
            Add Entry
          </Button>
        </Box>
      </Box>
    </Toolbar>
  );
});
